import { render } from "./TestimonialComponent.vue?vue&type=template&id=6175a667&scoped=true"
import script from "./TestimonialComponent.vue?vue&type=script&lang=js"
export * from "./TestimonialComponent.vue?vue&type=script&lang=js"

import "./TestimonialComponent.vue?vue&type=style&index=0&id=6175a667&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6175a667"]])

export default __exports__